<template>
  <div>
    <v-alert color="error" icon="error" class="ma-0 pa-2" outline :value="!loading.service && !isServiceActive">
      <div class="primary--text">
        Sorry, the notification system cannot be reached right now. Please reload the page in a few minutes &mdash; let
        us know
        if the issue persists!
      </div>
    </v-alert>
  </div>
</template>

<script>
  export default {
    props: {
      loading: Object,
    },
    computed: {
      isServiceActive() {
        return this.$store.getters['importnotification/isServiceActive']
      },
    },
  }
</script>